import axios from 'axios'
import {createSlice, createAsyncThunk, PayloadAction} from '@reduxjs/toolkit'
const api = '/api/'

export const bookDepreciationList = createAsyncThunk(
  'book-depreciation-list',
  async (params: {}, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-book-depreciation/list`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const storeBookDepreciation = createAsyncThunk(
  'book-depreciation-store',
  async (data: {}, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-book-depreciation/store`, data)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const getBookDepreciationById = createAsyncThunk(
  'book-depreciation-get',
  async (id: any, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-book-depreciation/edit/` + id)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data)
      }
    }
  }
)

export const bookDepreciationReport = createAsyncThunk(
  'book-depreciation-report',
  async (params: any, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-book-depreciation/report`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const printBookDepreciationReport = createAsyncThunk(
  'print-book-depreciation-report',
  async (params: any, thunkAPI) => {
    try {
      const response = await axios.post(`${api}school-book-depreciation/report-print`, params)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const getSchoolExistsBookList = createAsyncThunk(
  'school-exists-book-list',
  async (__, thunkAPI) => {
    try {
      const response = await axios.get(`${api}school-book-depreciation/get_exists_book_stock`)
      return response.data
    } catch (error: any) {
      if (error.response.data) {
        return thunkAPI.rejectWithValue(error.response.data.errors)
      }
    }
  }
)

export const BookStock = createAsyncThunk('book-stock', async (id: any, thunkAPI) => {
  try {
    const response = await axios.get(`${api}school-book-depreciation/book-stock/${id}`)
    return response.data
  } catch (error: any) {
    if (error.response.data) {
      return thunkAPI.rejectWithValue(error.response.data.errors)
    }
  }
})

type DepreciationState = {
  errors: any
}

const initialState: DepreciationState = {
  errors: '',
}

export const bookDepreciationSlice = createSlice({
  name: 'book-depreciation',
  initialState,
  reducers: {
    reset: () => initialState,
  },
  extraReducers: (builder) => {
    builder.addCase(storeBookDepreciation.rejected, (state, action: PayloadAction<any>) => {
      state.errors = action.payload
    })
  },
})

export const {reset} = bookDepreciationSlice.actions
export default bookDepreciationSlice.reducer
